export default __webpack_public_path__ + "static/media/2.701c4212.png";